// Adapted Trie from https://learnersbucket.com/tutorials/data-structures/trie-data-structure-in-javascript/
// we start with the TrieNode
var TrieNode = function TrieNode(key) {
  // the "key" value will be the character in sequence
  this.key = key; // we keep a reference to parent

  this.parent = null; // we have hash of children

  this.children = {}; // check to see if the node is at the end

  this.end = false;

  this.getWord = function () {
    var output = [];
    var node = this;

    while (node !== null) {
      output.unshift(node.key);
      node = node.parent;
    }

    return output.join('');
  };
};

var Trie = function Trie(maxWords) {
  this.root = new TrieNode(null);
  this.words = new Set();
  this.wordsDatetime = {}; // inserts a word into the trie.

  this.insert = function (word, date) {
    if (date === void 0) {
      date = new Date().getTime();
    }

    if (this.words.size >= maxWords) {
      var firstWord = this.allWords()[0];
      this.words["delete"](firstWord);
      delete this.wordsDatetime[firstWord];
      this.remove(firstWord);
    }

    if (this.words.has(word)) {
      this.wordsDatetime[word] = date;
    } else {
      this.words.add(word);
      this.wordsDatetime[word] = date;
      var node = this.root; // we start at the root
      // for every character in the word

      for (var i = 0; i < word.length; i++) {
        // check to see if character node exists in children.
        if (!node.children[word[i]]) {
          // if it doesn't exist, we then create it.
          node.children[word[i]] = new TrieNode(word[i]); // we also assign the parent to the child node.

          node.children[word[i]].parent = node;
        } // proceed to the next depth in the trie.


        node = node.children[word[i]]; // finally, we check to see if it's the last word.

        if (i === word.length - 1) {
          // if it is, we set the end flag to true.
          node.end = true;
        }
      }
    }
  }; // check if it contains a whole word.


  this.contains = function (word) {
    var node = this.root; // for every character in the word

    for (var i = 0; i < word.length; i++) {
      // check to see if character node exists in children.
      if (node.children[word[i]]) {
        // if it exists, proceed to the next depth of the trie.
        node = node.children[word[i]];
      } else {
        // doesn't exist, return false since it's not a valid word.
        return false;
      }
    } // we finished going through all the words, but is it a whole word?


    return node.end;
  }; // returns every word with given prefix


  this.find = function (prefix) {
    var _this = this;

    var node = this.root;
    var output = []; // for every character in the prefix

    for (var i = 0; i < prefix.length; i++) {
      // make sure prefix actually has words
      if (node.children[prefix[i]]) {
        node = node.children[prefix[i]];
      } else {
        // there's none. just return it.
        return output;
      }
    } // recursively find all words in the node


    findAllWords(node, output);
    output = output.sort(function (a, b) {
      return _this.wordsDatetime[b] - _this.wordsDatetime[a];
    });
    return output;
  };

  this.allWords = function () {
    var _this2 = this;

    return Array.from(this.words).sort(function (a, b) {
      return _this2.wordsDatetime[a] - _this2.wordsDatetime[b];
    });
  }; // recursive function to find all words in the given node.


  var findAllWords = function findAllWords(node, arr) {
    // base case, if node is at a word, push to output
    if (node.end) {
      arr.unshift(node.getWord());
    } // iterate through each children, call recursive findAllWords


    for (var child in node.children) {
      findAllWords(node.children[child], arr);
    }
  }; // removes a word from the trie.


  this.remove = function (word) {
    var root = this.root;

    if (!word) {
      return;
    }

    this.words["delete"](word);
    delete this.wordsDatetime[word]; // recursively finds and removes a word

    var removeWord = function removeWord(node, word) {
      // check and see if node has children
      var hasChildren = Object.keys(node.children).length > 0; // check if current node contains the word

      if ((node === null || node === void 0 ? void 0 : node.end) && node.getWord() === word) {
        // if has children we only want to un-flag the end node that marks the end of a word.
        // this way we do not remove words that contain/include supplied word
        if (hasChildren) {
          node.end = false;
        } else {
          // remove word by getting parent and remove children key
          delete node.parent.children[node.key];
        }

        return true;
      } // recursively remove word from all children


      if (node && hasChildren) {
        for (var key in node.children) {
          removeWord(node.children[key], word);
        }
      }

      return false;
    }; // call remove word on root node


    removeWord(root, word);
  };
};

export default Trie;